import { typeMeta } from "./clientConstants";

export function TypeBadge({ type }) {
  const meta = typeMeta(type);
  return (
    <span data-testid={`client-type-badge-${type}`} className="inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium" style={{ backgroundColor: meta.bg, color: meta.fg }}>
      {meta.label}
    </span>
  );
}

const STATUS_META = {
  active: { label: "Active", bg: "#E5F7ED", fg: "#087443", dot: "#087443" },
  inactive: { label: "Inactive", bg: "#F1F2F4", fg: "#51565F", dot: "#94A3B8" },
  archived: { label: "Archived", bg: "#FBF2E1", fg: "#8A6529", dot: "#C79A3C" },
};

export function StatusPill({ status }) {
  const meta = STATUS_META[status] || STATUS_META.active;
  return (
    <span data-testid={`client-status-pill-${status}`} className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium" style={{ backgroundColor: meta.bg, color: meta.fg }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: meta.dot }} />{meta.label}
    </span>
  );
}
